module.exports = __webpack_public_path__ + "img/gouwuche.d5dc360b.png";